import { render, staticRenderFns } from "./myorders.vue?vue&type=template&id=537c3a2c&scoped=true"
import script from "./myorders.vue?vue&type=script&lang=js"
export * from "./myorders.vue?vue&type=script&lang=js"
import style0 from "./myorders.vue?vue&type=style&index=0&id=537c3a2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c3a2c",
  null
  
)

export default component.exports